import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from "../environments/environment";

const { msalConfig } = environment;

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('auth.access_token');
  const expiresOn = localStorage.getItem('auth.expires_on');
  
  const urlInseguras: any[] = [ 
    msalConfig.auth.authority.replace('/v2.0', '/oauth2/v2.0/token'),
    msalConfig.auth.authority.replace('/v2.0', '/oauth2/v2.0/authorize')
  ];

  // Skip auth URLs and JSONP requests
  if(urlInseguras.includes(req.url) || req.method === 'JSONP') {
    return next(req);
  }

  // Add token to request if available and not expired
  if(token && expiresOn) {
    const isExpired = parseFloat(expiresOn) < Date.now() / 1000;
    
    if(!isExpired) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next(authReq);
    }
  }

  return next(req);
}